import React from 'react'
import { useMount } from 'react-use'
import { Field } from 'redux-form'

import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import { Table, TableHeader, TableRow } from 'features/Table'
import Button from 'components/Button/Button'
import { Input } from 'components/Input/Input'
import SelectPretty from 'components/Input/SelectPretty'
import IconPlus from 'components/Icons/Plus'
import Tooltip from 'components/Tooltip'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import s from './HostedVoiceServicesList.scss'

export const HostedVoiceServicesListComponent = props => {
  const {
    loading,
    services,
    filterOptions,

    listServices,
    showMobileServiceFormModal,
  } = props

  useMount(() => {
    listServices()
  })

  if (loading) {
    return <LoadingOverlay transparent />
  }

  const hasMultipleBans = filterOptions.hasMultipleBans()

  const tableHeader = (
    <TableHeader>
      {hasMultipleBans ? <div>BAN</div> : null}
      <div>Number</div>
      <div>Ref</div>
      <div>Status</div>
      <div>Service Type</div>
      <div style={{ maxWidth: '76px' }}></div>
    </TableHeader>
  )

  return (
    <>
      <div className={cn(sMarg.mb30, sLay['layout-row'])}>
        <Field
          label="Search"
          component={Input}
          name="search"
          display="box"
          hideDot
          classNameOuter={cn(s.searchBox, s.filterBox)}
        />
        {hasMultipleBans ? (
          <Field
            label="BAN"
            component={SelectPretty}
            name="ban"
            options={filterOptions.ban}
            display="box"
            className={s.filterBox}
          />
        ) : null}
        <Field
          label="Status"
          component={SelectPretty}
          name="status"
          options={filterOptions.status}
          display="box"
          className={s.filterBox}
        />
        <Field
          label="Service Type"
          component={SelectPretty}
          name="serviceType"
          options={filterOptions.serviceType}
          display="box"
          className={s.filterBox}
        />
        <Button
          className={s.createButton}
          color="tertiary"
          size="sm"
          rect
          onClick={() => showMobileServiceFormModal()}
        >
          <IconPlus size={32} />
          <Tooltip>Add New Service</Tooltip>
        </Button>
      </div>

      {services.length ? (
        <Table header={tableHeader}>
          {services.map(service => (
            <TableRow key={service.id}>
              {hasMultipleBans ? <div>{service.ban}</div> : null}
              <div>{service.number}</div>
              <div>{service.customerReference}</div>
              <div>{service.billingStatus}</div>
              <div>{service.serviceType}</div>
              <div style={{ maxWidth: '76px' }}>
                <Button
                  disabled={service.billingStatus !== 'Active'}
                  color="tertiary"
                  size="xs"
                  ghost
                  to={`/dashboard/hosted-voice/${service.id}`}
                >
                  View
                </Button>
              </div>
            </TableRow>
          ))}
        </Table>
      ) : (
        <EmptyMessageCard title="You have no Hosted Voice Services" />
      )}
    </>
  )
}



// WEBPACK FOOTER //
// src/features/Services/HostedVoice/HostedVoiceServicesList/HostedVoiceServicesList.tsx